const createMarkup = (html) => ({
  __html: decodeHtml(html), // TODO: remove decode once real data is fetched
})

const decodeHtml = (html) => {
  const el = document.createElement('textarea')
  el.innerHTML = html

  return el.value
}

export { createMarkup, decodeHtml }
